import fetchJsonp from "fetch-jsonp";
import { buildParamsFromTags } from "../functions/buildParamsFromTags";
import { transformToParams } from "../functions/transformToParams";
import { DECLARATIVE_TAGS_FORM } from "../config";
import {
  ERRORA_MSG,
  SPINNER,
  SUCCESS_MSG,
} from "../functions/new-form/uiTemplates";

export function addLeadForm({ data }) {
  if (typeof DFI_client.getCookie == "undefined") {
    window.DFI_client.getCookie = function (name) {
      let match = document.cookie.match(new RegExp(name + "=([^;]+)"));
      if (match) return match[1];
    };
  }

  const DEFAULT_TAGS = buildParamsFromTags({
    declarativeTags: DECLARATIVE_TAGS_FORM,
  });
  const TAGS_FROM_USER_FIELDS = transformToParams(data);
  const ID_LEAD = transformToParams({
    idlead: window.Piwik.getAsyncTracker().getVisitorId(),
  });
  const D1C_TAGS = transformToParams(window.DFI.labels.EDeclaratives);
  const CLIENT_ID = transformToParams({
    clientId: window.DFI_client.getCookie("_ga"),
  });

  const URL = `${DEFAULT_TAGS}${TAGS_FROM_USER_FIELDS}${ID_LEAD}${D1C_TAGS}${CLIENT_ID}`;
  const $btnSubmit = document.querySelector(".wm-form__submit");

  $btnSubmit.innerHTML = SPINNER;
  $btnSubmit.setAttribute("disabled", true);

  console.log(URL);

  return fetchJsonp(URL)
    .then((res) => res.json())
    .then(({ result }) => {
      setTimeout(() => {
        console.log(result);

        if (result === "OK") {
          $btnSubmit.innerHTML = SUCCESS_MSG;
          $btnSubmit.classList.add("success");
        }

        if (result === "KO") {
          $btnSubmit.innerHTML = ERRORA_MSG;
          $btnSubmit.classList.add("error");
        }
      }, 2000);
    });
}
